(function (root) {
  'use strict';
  const SHADES = ['5', '10', '15', '20', '25', '30', '35', '50', '70'];
  const singleLine = (value, max = 80) => typeof value === 'string' && value.trim().length <= max && !/[\r\n]/.test(value);
  function yearsFor(model, body, coverage) {
    if (coverage === 'front-two') return body === 'SuperCrew' ? [2020, 2019, 2018, 2017, 2016, 2015] : [];
    const years = new Set();
    for (const range of model.ranges.filter(r => r.body === body)) for (let year = range.start; year <= range.end; year++) years.add(year);
    return Array.from(years).sort((a, b) => b - a);
  }
  function selection(data, fields) {
    const model = data.model, frontOnly = fields.coverage === 'front-two';
    const body = fields.body === '__other' ? String(fields.otherBody || '').trim() : fields.body;
    const year = fields.year === '__other' ? String(fields.otherYear || '').trim() : fields.year;
    if (!singleLine(body) || !body || !/^(19|20)\d{2}$/.test(year || '')) throw Error('Choose your actual body or cab style and model year.');
    if (!SHADES.includes(fields.frontShade)) throw Error('Choose a front side-window shade.');
    if (!frontOnly && !SHADES.includes(fields.rearShade)) throw Error('Choose a rear sides and rear-glass shade.');
    const rearGlass = frontOnly ? '' : model.slug === 'ford-f-150' ? fields.rearGlass : 'Fixed rear glass';
    if (!frontOnly && (!rearGlass || !singleLine(rearGlass))) throw Error('Choose the rear-glass layout.');
    if (!singleLine(fields.trim || '', 80)) throw Error('Keep the trim and glass notes to 80 characters on one line.');
    const trim = (fields.trim || '').trim();
    const vehicle = [year, model.make, model.model, body].join(' ') + (rearGlass ? '; rear glass: ' + rearGlass : '') + (trim ? '; trim: ' + trim : '');
    if (vehicle.length > 240) throw Error('Shorten your trim and glass notes so all vehicle details fit in the order.');
    const product = frontOnly ? data.frontTwo : data.kit;
    if (!product || !product.handle) throw Error('This coverage is not available.');
    const variant = product.variants.find(v => v.available && String(v.frontShade).replace('%', '') === fields.frontShade && (!frontOnly || String(v.year) === year));
    const listed = yearsFor(model, body, fields.coverage).includes(Number(year));
    const shadeRule = !frontOnly && (model.rules || []).find(rule => Number(year) >= rule.start && Number(year) <= rule.end && (!rule.body || rule.body === body) && (fields.frontShade !== rule.requiredShade || fields.rearShade !== rule.requiredShade));
    const needsCheck = !listed || fields.modified === 'yes' || Boolean(shadeRule);
    if (!needsCheck && !variant) throw Error('The selected kit shade is currently unavailable.');
    return {model: model.slug, vehicle, year, body, rearGlass, trim, frontShade: fields.frontShade, rearShade: frontOnly ? '' : fields.rearShade, coverage: frontOnly ? 'front-two' : 'sides-rear', variant, product, needsCheck, reason: shadeRule ? shadeRule.message : !listed ? 'This year or body needs a pattern check. Send your actual details to MotorPeak.' : fields.modified === 'yes' ? 'Replacement or modified glass needs a pattern check before ordering.' : ''};
  }
  function destination(data, chosen) {
    const url = new URL(chosen.needsCheck ? data.contactUrl : data.root + 'products/' + chosen.product.handle, root.location ? root.location.origin : 'https://motorpeaksupply.com');
    const values = {vehicle: chosen.vehicle, year: chosen.year, make: data.model.make, model: data.model.model, body: chosen.body, rearGlass: chosen.rearGlass, trim: chosen.trim, frontShade: chosen.frontShade, rearShade: chosen.rearShade};
    for (const [key, value] of Object.entries(values)) if (value) url.searchParams.set(key, value);
    if (!chosen.needsCheck && chosen.variant) url.searchParams.set('variant', chosen.variant.id);
    if (!chosen.needsCheck && chosen.coverage === 'sides-rear') url.hash = 'mp-vehicle-information';
    return url;
  }
  const api = {yearsFor, selection, destination};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.MotorPeakPurchase = api;
  if (!root.customElements || root.customElements.get('motorpeak-purchase-panel')) return;

  class PurchasePanel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-mp-purchase-data]').textContent);
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-mp-purchase-status]');
      this.button = this.querySelector('[data-mp-purchase-continue]');
      this.money = new Intl.NumberFormat(undefined, {style: 'currency', currency: this.data.currency});
      this.key = 'motorpeak-tint-selection:' + this.data.model.slug;
      this.linkOriginal = new WeakMap();
      this.form.addEventListener('change', event => {
        if (event.target.name === 'coverage') this.coverageChanged();
        if (event.target.name === 'body') this.populateYears();
        this.showOtherFields(); this.update();
      });
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.form.reportValidity()) return;
        try { const chosen = selection(this.data, this.fields()); root.location.assign(destination(this.data, chosen).href); }
        catch (error) { this.status.textContent = error.message; }
      });
      let saved = {};
      try { saved = JSON.parse(root.sessionStorage.getItem(this.key) || '{}'); } catch (_) {}
      const query = new URLSearchParams(root.location.search);
      for (const key of ['coverage', 'body', 'year', 'otherYear', 'otherBody', 'rearGlass', 'trim', 'frontShade', 'rearShade', 'modified']) {
        const value = query.has(key) ? query.get(key) : saved[key];
        if (singleLine(value, 80)) this.setField(key, value);
      }
      this.coverageChanged();
      const requestedYear = query.get('year') || saved.year;
      this.populateYears(requestedYear);
      this.showOtherFields(); this.update();
      root.document.querySelectorAll('[data-mp-purchase-open]').forEach(link => link.addEventListener('click', () => {
        const details = this.querySelector('details[data-mp-purchase-config]');
        if (details) details.open = true;
      }));
    }
    setField(name, value) {
      const field = this.form.elements.namedItem(name);
      if (!field) return;
      if (field.tagName !== 'SELECT' || Array.from(field.options).some(option => option.value === value)) field.value = value;
    }
    fields() { return Object.fromEntries(new FormData(this.form)); }
    coverageChanged() {
      const frontOnly = this.form.elements.coverage.value === 'front-two';
      const body = this.form.elements.body, old = body.value;
      const choices = frontOnly ? ['SuperCrew'] : this.data.model.bodies.filter(value => !value.startsWith('Other'));
      body.replaceChildren(new Option(frontOnly ? 'SuperCrew' : 'Choose body / cab', frontOnly ? 'SuperCrew' : ''), ...(!frontOnly ? choices.map(value => new Option(value, value)) : []), ...(!frontOnly ? [new Option('Other body — ask us', '__other')] : []));
      if (choices.includes(old) || (!frontOnly && old === '__other')) body.value = old;
      if (frontOnly) body.value = 'SuperCrew';
      for (const field of this.querySelectorAll('[data-mp-purchase-rear]')) field.hidden = frontOnly;
      this.form.elements.rearShade.disabled = frontOnly;
      this.form.elements.rearShade.required = !frontOnly;
      const rear = this.form.elements.rearGlass;
      rear.disabled = frontOnly || this.data.model.slug !== 'ford-f-150';
      rear.required = !rear.disabled;
      this.querySelector('[data-mp-purchase-truck-glass]').hidden = rear.disabled;
      this.populateYears();
    }
    populateYears(requested) {
      const year = this.form.elements.year, old = requested || year.value;
      const years = yearsFor(this.data.model, this.form.elements.body.value, this.form.elements.coverage.value);
      year.replaceChildren(new Option('Choose model year', ''), ...years.map(value => new Option(String(value), String(value))), new Option('Other year — ask us', '__other'));
      if (Array.from(year.options).some(option => option.value === old)) year.value = old;
      else if (/^(19|20)\d{2}$/.test(old || '')) { year.value = '__other'; this.form.elements.otherYear.value = old; }
    }
    showOtherFields() {
      for (const [name, condition] of [['otherYear', this.form.elements.year.value === '__other'], ['otherBody', this.form.elements.body.value === '__other']]) {
        const field = this.form.elements[name]; field.closest('label').hidden = !condition; field.disabled = !condition; field.required = condition;
      }
    }
    update() {
      const fields = this.fields(), frontOnly = fields.coverage === 'front-two';
      const product = frontOnly ? this.data.frontTwo : this.data.kit;
      const price = this.money.format(product.price / 100);
      this.querySelector('[data-mp-purchase-price]').textContent = price;
      this.querySelector('[data-mp-purchase-coverage]').textContent = frontOnly ? 'Driver + passenger front-door film · 2015–2020 SuperCrew' : 'Side windows + rear glass · choose your exact year and body';
      this.button.disabled = true;
      this.button.textContent = 'Continue with this kit — ' + price;
      let chosen;
      try {
        chosen = selection(this.data, fields);
        this.button.disabled = false;
        this.button.textContent = chosen.needsCheck ? 'Ask MotorPeak about this configuration' : 'Continue with this kit — ' + price;
        this.status.textContent = chosen.reason || chosen.vehicle + ' · Front ' + chosen.frontShade + '%' + (frontOnly ? '' : ' / rear ' + chosen.rearShade + '%') + '. Your choices carry to the kit form for review.';
      } catch (error) { this.status.textContent = error.message; }
      try { root.sessionStorage.setItem(this.key, JSON.stringify(fields)); } catch (_) {}
      this.updateLinks(chosen);
    }
    updateLinks(chosen) {
      const modelPath = this.data.root + 'pages/' + this.data.model.slug + '-pre-cut-window-tint';
      const guidePath = this.data.root + 'blogs/installation-guides/' + this.data.model.slug + '-window-tint-installation-guide';
      for (const link of root.document.querySelectorAll('a[href]')) {
        if (link.hasAttribute('data-mp-purchase-open')) continue;
        if (!this.linkOriginal.has(link)) this.linkOriginal.set(link, link.getAttribute('href'));
        let url; try { url = new URL(this.linkOriginal.get(link), root.location.origin); } catch (_) { continue; }
        if (url.origin !== root.location.origin) continue;
        const isKit = url.pathname === this.data.root + 'products/' + this.data.kit.handle;
        const isModel = url.pathname === modelPath, isGuide = url.pathname === guidePath;
        if (!(isKit || isModel || isGuide)) continue;
        if (chosen && !chosen.needsCheck) {
          const selected = destination(this.data, chosen);
          if (isKit) { const mediaAnchor = url.hash; url = selected; if (mediaAnchor && mediaAnchor !== '#mp-vehicle-information') url.hash = mediaAnchor; }
          else for (const [key, value] of selected.searchParams) if (key !== 'variant') url.searchParams.set(key, value);
        } else if (isKit && !url.hash) { url = new URL(modelPath, root.location.origin); }
        link.href = url.href;
      }
    }
  }
  root.customElements.define('motorpeak-purchase-panel', PurchasePanel);
})(typeof window === 'undefined' ? globalThis : window);
